import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ImpersonationCandidateVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { ROLES } from "@user-management-context/shared/domain/types/enums/roles";

export const retrieveImpersonationCandidates = createAsyncThunk<ImpersonationCandidateVM[], ROLES, { extra: Partial<Dependencies> }>(
  "users/retrieveImpersonationCandidates",
  async (role, { extra: { adminRepository } }) => {
    return adminRepository!.getImpersonationCandidates(role);
  },
);
